import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getOfflineEncryptionDataQueryKey = (): UseDataQuery['queryKey'] => [
  'offline/key',
  undefined,
];
